import axiosOverlay from "../../js/axiosOverlay";

const state = {
    pictures: null,
    picturesToSend: null,
    selectedPictures: null
};

const getters = {
    pictures: state => state.pictures,
    picturesToSend: state => state.picturesToSend,
    selectedPictures: state => state.selectedPictures
};

const mutations = {
    SET_PICTURES(state, pictures) {
        state.pictures = pictures;
    },
    SET_PICTURES_TO_SEND(state, pictures) {
        state.picturesToSend = pictures;
    },
    SET_SELECTED_PICTURES(state, pictures) {
        state.selectedPictures = pictures;
    }
};

const actions = {
    async getPicturesOfSollicitation(context, sollicitation) {
        let config = {
            method: 'get',
            url: process.env.VUE_APP_API_URL + "/sollicitation/fichiers?sollicitation_id=" + sollicitation,
        };

        try {
            const response = await axiosOverlay(config);
            let result = response.data;
            return result;
        } catch (error) {
            console.log(error);
            return null;
        }
    },
    
    async uploadPicture(context, { image, sollicitation, mimeType, extension }) {
        let date = new Date();
        let dateStr =
            ("00" + (date.getMonth() + 1)).slice(-2) + "-" +
            ("00" + date.getDate()).slice(-2) + "-" +
            date.getFullYear() + "_" +
            ("00" + date.getHours()).slice(-2) + "-" +
            ("00" + date.getMinutes()).slice(-2) + "-" +
            ("00" + date.getSeconds()).slice(-2);

        let arrayData = {
            "name_file": "photo_" + dateStr + extension,
            "file": image,
            "sollicitation": sollicitation,
            "type": mimeType
        }

        let data = JSON.stringify(arrayData)

        let config = {
            method: 'post',
            url: process.env.VUE_APP_API_URL + "/sollicitation_upload_file",
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        try {
            const response = await axiosOverlay(config);
            if (response.status === 200 || response.status === 201) {
                return true;
            } else {
                return false;
            }
        } catch (error) {
            console.log('error', error);
            return false;
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
